import type { RootState } from '@/redux-store';
import { store } from '@/redux-store';
import { Role } from '../role';

export class CustomerRole extends Role {
    public queryById(): null | string {
        const state = store.getState() as RootState;

        const customerId = state.auth.userInformation?.customerId;

        return customerId || null;
    }

    public getInformationHomeRoute() {
        return {
            routeKey: this.routeManager.CUSTOMER_DETAIL,
            params: {
                id: this.queryById(),
                breadcrumb: [{ routeKey: this.routeManager.HOME }],
            },
        };
    }

    public canLeaveReview(): boolean {
        return true;
    }

    public canUpdateSignature(): boolean {
        return true;
    }

    public defaultRoute(): string {
        return this.routeManager.HOME;
    }
}
